import {
  FlaskConical, LayoutGrid, TriangleAlert, Zap, ClipboardList, Boxes, BarChart3, Upload,
  TrendingUp, CloudLightning, Settings, BookOpen, Package, type LucideIcon,
} from 'lucide-react';

export interface NavItem {
  label: string;
  path: string;
  icon: LucideIcon;
  badgeKey?: 'alerts' | 'recommendations';
}

export interface NavSection {
  title: string;
  items: NavItem[];
}

export const NAV: NavSection[] = [
  {
    title: 'Resumen',
    items: [
      { label: 'Recorrido guiado', path: '/recorrido', icon: FlaskConical },
      { label: 'Dashboard Ejecutivo', path: '/', icon: LayoutGrid },
      { label: 'Centro de Alertas', path: '/alertas', icon: TriangleAlert, badgeKey: 'alerts' },
    ],
  },
  {
    title: 'Compras e Inventario',
    items: [
      { label: 'Recomendaciones IA', path: '/recomendaciones', icon: Zap, badgeKey: 'recommendations' },
      { label: 'Órdenes de Compra', path: '/ordenes', icon: ClipboardList },
      { label: 'Semáforo Inventario', path: '/inventario', icon: Boxes },
      // Aparte del semáforo a propósito: un combo no tiene stock propio (ticket 8).
      { label: 'Combos y Surtidos', path: '/combos', icon: Package },
      { label: 'Demanda Insatisfecha', path: '/demanda', icon: BarChart3 },
      { label: 'Importar Datos', path: '/importar', icon: Upload },
    ],
  },
  {
    title: 'Análisis Predictivo',
    items: [
      { label: 'Forecast y Proyecciones', path: '/forecast', icon: TrendingUp },
      { label: 'Factores Externos', path: '/factores', icon: CloudLightning },
    ],
  },
  {
    title: 'Sistema',
    items: [
      { label: 'Plan del Producto', path: '/plan', icon: BookOpen },
      { label: 'Configuración', path: '/configuracion', icon: Settings },
    ],
  },
];

// Page title shown in the top bar, keyed by route path.
export const PAGE_TITLES: Record<string, string> = {
  '/': 'Dashboard Ejecutivo',
  '/alertas': 'Centro de Alertas',
  '/recomendaciones': 'Recomendaciones de Compra — IA',
  '/ordenes': 'Órdenes de Compra',
  '/inventario': 'Semáforo de Inventario',
  '/combos': 'Combos y Surtidos',
  '/demanda': 'Demanda Insatisfecha',
  '/importar': 'Importar Datos al Sistema',
  '/forecast': 'Forecast y Proyecciones',
  '/factores': 'Factores Externos y Eventos',
  '/plan': 'Plan del Producto',
  '/configuracion': 'Configuración del Sistema',
};
